import { Injectable } from '@angular/core';
import { Cookies } from 'typescript-cookie';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  // TODO: add here isSysAdmin?
  getProfile() {
    return Cookies.get('user') || '';
    //return ['Usuario','user@claro.com',];
  }
}
